import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography, Box } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import menuItem, { categoryStyles } from 'menu-items';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const theme = useTheme();

  // Identificar si el elemento tiene un tipo de sección
  const isSection = item.type === 'section';

  // Determinar color de la sección basado en la categoría
  const sectionColor = item.category && categoryStyles ? categoryStyles[item.category]?.color : theme.palette.text.primary;

  // menu list collapse & items
  const items = item.children?.map((menu) => {
    switch (menu.type) {
      case 'section':
        // Secciones anidadas
        return (
          <Box key={menu.id} sx={{ mb: 1.5, mt: 1.5 }}>
            <Typography
              variant="subtitle2"
              sx={{
                pl: 3,
                mb: 1.5,
                mt: 1.5,
                color: menu.category && categoryStyles ? categoryStyles[menu.category]?.color : theme.palette.text.secondary,
                fontWeight: 600,
                textTransform: 'uppercase',
                fontSize: '0.75rem',
                letterSpacing: '0.5px'
              }}
            >
              {menu.title}
            </Typography>
            {menu.children?.map((subMenu) => {
              switch (subMenu.type) {
                case 'collapse':
                  return <NavCollapse key={subMenu.id} menu={subMenu} level={1} />;
                case 'item':
                  return <NavItem key={subMenu.id} item={subMenu} level={1} />;
                default:
                  return (
                    <Typography key={subMenu.id} variant="h6" color="error" align="center">
                      Menu Items Error
                    </Typography>
                  );
              }
            })}
            <Divider sx={{ mt: 2, mb: 2, opacity: 0.25 }} />
          </Box>
        );
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case 'item':
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List
        subheader={
          item.title &&
          !isSection && (
            <Typography
              variant="caption"
              sx={{
                ...theme.typography.menuCaption,
                color: theme.palette.text.primary
              }}
              display="block"
              gutterBottom
            >
              {item.title}
              {item.caption && (
                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
      >
        {items}
      </List>

      {/* group divider - solo si no es una sección */}
      {!isSection && <Divider sx={{ mt: 0.25, mb: 1.25 }} />}
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;
